import type { Site } from '../domain/inventory';

type SiteIdentity = Pick<Site, 'name' | 'displayName'>;
type SearchableSiteIdentity = SiteIdentity & Pick<Site, 'id' | 'officialSiteId'>;

export function siteDisplayName(site: SiteIdentity | undefined, fallback = '—'): string {
  return site?.displayName?.trim() || site?.name.trim() || fallback;
}

export function siteCode(site: SiteIdentity | undefined): string | undefined {
  const code = site?.name.trim();
  const displayName = site?.displayName?.trim();
  if (!code || !displayName) return undefined;
  if (code.localeCompare(displayName, undefined, { sensitivity: 'base' }) === 0) return undefined;
  return code;
}

export function siteLabel(site: SiteIdentity | undefined, fallback = '—'): string {
  const displayName = siteDisplayName(site, fallback);
  const code = siteCode(site);
  return code ? `${displayName} · ${code}` : displayName;
}

export function siteSearchAliases(site: SearchableSiteIdentity): string[] {
  return [site.name, site.id, site.officialSiteId ?? ''].filter(Boolean);
}
